import DataGrid, {
    Column,
    ColumnChooser,
    ColumnFixing, Export, Grouping,
    GroupPanel,
    HeaderFilter, Pager,
    Paging,
    SearchPanel,
    SortByGroupSummaryInfo
}
    from 'devextreme-react/data-grid'; //npm install devextreme@19.1 devextreme-react@19.1
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import React, { Component } from 'react';
import Modal from 'react-modal'; //npm install --save react-modal
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import ReactTooltip from "react-tooltip"; //npm install react - tooltip
import DateBox from 'devextreme-react/date-box';
import { ChangePasswordComponent } from '../Shared/ChangePasswordComponent';
import { SetUserLocationComponent } from '../Shared/SetUserLocationComponent';
import { MasterHistoryComponent } from '../Shared/MasterHistoryComponent';
import NumberFormat from 'react-number-format';
import { getRequestParams, formatDate } from '../../helpers/globalfunctions.js';
import { NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import QRCode from 'qrcode.react'; //npm i qrcode.react
import { post, axios } from 'axios'; //npm install--save axios
import { LoadPanel } from 'devextreme-react/load-panel';
import { ApplicationType } from '../../helpers/fixcodes.js';
import { DriverDocumentComponent } from '../Reimbursment/DriverDocumentComponent';

const MySwal = withReactContent(Swal)
const customStyles = {
    content: {
        width: '70%',

    }
};
const qrCodeCustomStyles = {
    content: {
        width: '40%',
    }
};
const position = { of: '#historydiv' };

let currentTime = sessionStorage.getItem("session_locationTime") == "" ? new Date() : new Date(sessionStorage.getItem("session_locationTime"));
export class DriverListComponent extends Component {
    constructor(props) {
        super(props);
        currentTime = sessionStorage.getItem("session_locationTime") == "" ? new Date() : new Date(sessionStorage.getItem("session_locationTime"));
        this.state = {
            isSubmited: false,
            loadPanelVisible: false,
            datasource: null,
            isOpenDriverModal: false,
            qrCodeModalIsOpen: false,
            driverId: 0,
            userName: '',
            password: '',
            firstName: '',
            lastName: '',
            mobileNumber: '',
            countryCode: '',
            email: '',
            address: '',
            isActive: true,
            isLocked: false,
            inactiveReason: '',
            lockedReason: '',
            isPreventAccess: false,
            preventReason: '',
            licenceDocumentId: 0,
            licenceNumber: '',
            documentName: '',
            expiryDate: '',
            validFrom: '',
            isDaysBeforeRemind: false,
            noOfDaysBeforeRemind: 0,
            fileGuid: '00000000-0000-0000-0000-000000000000',
            driverFile: "../../dist/img/avatar5.png",
            driverSelectedFile: [],
            appTypeId: parseInt(ApplicationType.UTPro),
            vIsPasswordComplexity: false,
            vMinLength: 0,
            vMinUpperCaseLetter: 0,
            vMinLowerCaseLetter: 0,
            vMinNumber: 0,
            vMinSpecialCharacter: 0,
            doNotDeleteDriver: sessionStorage.getItem("session_doNotDeleteDriver") === "true" ? true : false,
            
            errors: {
                userName: '',
                password: '',
                firstName: '',
                lastName: '',
                mobileNumber: '',
                countryCode: '',
                email: '',
                preventReason: '',
                noOfDaysBeforeRemind: '',
            }

        }
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleValidFromDateChange = this.handleValidFromDateChange.bind(this);
        this.handleExpiryDateChange = this.handleExpiryDateChange.bind(this);
        this.handleQRCodeOpenState = this.handleQRCodeOpenState.bind(this);
        this.handleDownloadDriverQRCode = this.handleDownloadDriverQRCode.bind(this);
        this.driverProfileUpload = this.driverProfileUpload.bind(this);

        this.getDriverList = this.getDriverList.bind(this);
        this.editDriverControl = this.editDriverControl.bind(this);
        this.deleteDriver = this.deleteDriver.bind(this);
        this.closeDriverModal = this.closeDriverModal.bind(this);
        this.afterOpenDriverModal = this.afterOpenDriverModal.bind(this);
        this.handleDriverSubmit = this.handleDriverSubmit.bind(this);
        this.onToolbarPreparing = this.onToolbarPreparing.bind(this);
        this.openPasswordModal = this.openPasswordModal.bind(this);
        this.openLocationModal = this.openLocationModal.bind(this);
        this.removeImageHandle = this.removeImageHandle.bind(this);

        this.getValidationRules = this.getValidationRules.bind(this);
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift({
            location: 'after',
            widget: 'dxButton',
            options: {
                icon: 'refresh',
                onClick: this.getDriverList.bind(this)
            }
        });
    }

    async componentDidMount() {
        this.setState({ loadPanelVisible: true });
        await this.getDriverList();
        await this.getValidationRules();
        this.setState({ loadPanelVisible: false });
    }

    async getValidationRules() {
        try {
            const requestParams = getRequestParams('GET', '');
            const response = await fetch('password-policy-api/validation-rule/' + sessionStorage.getItem('session_accountId') + '/' + parseInt(this.state.appTypeId), requestParams);
            const data = await response.json();
            if (data !== null && data.passwordValidationRule != null) {
                this.setState({
                    vIsPasswordComplexity: data.passwordValidationRule.isPasswordComplexity,
                    vMinLength: data.passwordValidationRule.minLength,
                    vMinUpperCaseLetter: data.passwordValidationRule.minUpperCaseLetter,
                    vMinLowerCaseLetter: data.passwordValidationRule.minLowerCaseLetter,
                    vMinNumber: data.passwordValidationRule.minNumber,
                    vMinSpecialCharacter: data.passwordValidationRule.minSpecialCharacter
                });
            }
        } catch (e) {
            console.log(e);
        }
    }

    async getDriverList() {        
        try {
            this.setState({ loadPanelVisible: true });
            const requestParams = getRequestParams('GET', '');
            const response = await fetch('driver-api/list/' + 0, requestParams);
            const data = await response.json();            
            this.setState({
                datasource: data.userDetails
            });
            this.setState({ loadPanelVisible: false });
        } catch (e) {
            this.setState({ loadPanelVisible: false });
            console.log(e);
        }
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        if (name == "countryCode") {
            const re = /^[0-9\b]+$/;
            if (event.target.value === '' || re.test(event.target.value)) {
                this.setState({ countryCode: event.target.value })
            }
        }
        else if (name == "password") {
            const re = /^[0-9a-zA-Z]+$/;
            if (event.target.value === '' || re.test(event.target.value)) {
                this.setState({ password: event.target.value })
                this.state.errors[name] = "";
            }
            else {
                this.state.errors[name] = "Please enter password in numbers, alphabets or alphanumeric only.";
            }
        } else if (name == "noOfDaysBeforeRemind") {
            const re = /^[0-9\b]+$/;
            if (event.target.value === '' || re.test(event.target.value)) {
                this.setState({ noOfDaysBeforeRemind: event.target.value })
            }
        } else if (name == "driverFile") {
            if (event.target.files.length > 0) {
                this.setState({ driverFile: URL.createObjectURL(event.target.files[0]) })
                this.setState({ driverSelectedFile: event.target.files[0] })
            }
        } else if (name == "userName") {
            const re = /^[a-z0-9]+$/;
            if (event.target.value === '' || re.test(event.target.value)) {
                this.setState({ userName: event.target.value })
            }
        } else {
            this.setState({
                [name]: value
            });
        }

        this.state.errors[name] = "";
    }

    handleValidFromDateChange(event) {
        let fromDateValue = formatDate(event.value, "MM/dd/yyyy");
        this.setState({ validFrom: fromDateValue })
    }
    handleExpiryDateChange(event) {
        let toDateValue = formatDate(event.value, "MM/dd/yyyy");
        this.setState({ expiryDate: toDateValue })
    }

    handleValidation() {
        let errors = this.state.errors;
        let formIsValid = true;
        errors.userName = "";
        errors.password = "";
        errors.firstName = "";
        errors.lastName = "";
        errors.mobileNumber = "";
        errors.countryCode = "";
        errors.email = "";
        errors.preventReason = "";
        errors.noOfDaysBeforeRemind = "";
        if (this.state.userName == null || this.state.userName.trim() == '') {
            formIsValid = false;
            errors.userName = "Please enter username.";
        }
        if (this.state.password == null || this.state.password.trim() == '') {
            formIsValid = false;
            errors.password = "Please enter password.";
        }
        if (this.state.password.trim() != '') {
            if (this.state.password.length < 5) {
                formIsValid = false;
                errors.password = "Password must minimum 5 characters long.";
            }
        }
        //if (this.state.driverId == 0 && this.state.password.trim() != '' && this.state.vIsPasswordComplexity == true) {
            //const renumbersymbolexp = /[^0-9]/g;
            //const lowercaseexp = /[^a-z]/g;
            //const uppercaseexp = /[^A-Z]/g;
            //const specialcharacters = /[^!@#$%^&*]/g;

            //var IsPwdnumbersymbol = this.state.password.replace(renumbersymbolexp, "").length;
            //var IsLowercase = this.state.password.replace(lowercaseexp, "").length;
            //var IsUppercase = this.state.password.replace(uppercaseexp, "").length;
            //var IsSpecialCharacters = this.state.password.replace(specialcharacters, "").length;

            //if (this.state.password.length < this.state.vMinLength) {
            //    formIsValid = false;
            //    errors.password = "Password must be " + this.state.vMinLength + " characters long";
            //}
            //else if (IsPwdnumbersymbol < this.state.vMinNumber) {
            //    formIsValid = false;
            //    errors.password = "Password must contains atleast " + this.state.vMinNumber + " number";
            //}
            //else if (IsLowercase < this.state.vMinLowerCaseLetter) {
            //    formIsValid = false;
            //    errors.password = "Password must contains atleast " + this.state.vMinLowerCaseLetter + " lowercase alphabet";
            //}
            //else if (IsUppercase < this.state.vMinUpperCaseLetter) {
            //    formIsValid = false;
            //    errors.password = "Password must contains atleast " + this.state.vMinUpperCaseLetter + " uppercase alphabet";
            //}
            //else if (IsSpecialCharacters < this.state.vMinSpecialCharacter) {
            //    formIsValid = false;
            //    errors.password = "Password must contains atleast " + this.state.vMinSpecialCharacter + " special character";
            //}
        //}
        if (this.state.firstName == null || this.state.firstName.trim() == '') {
            formIsValid = false;
            errors.firstName = "Please enter first name.";
        }
        if (this.state.lastName == null || this.state.lastName.trim() == '') {
            formIsValid = false;
            errors.lastName = "Please enter last name.";
        }
        if (this.state.mobileNumber == null || this.state.mobileNumber.trim() === "") {
            formIsValid = false;
            errors.mobileNumber = "Please enter mobile.";
        } else if (this.state.mobileNumber.trim().replace("(", "").replace(")", "").replace("-", "").replace(" ", "").length != 10) {
            formIsValid = false;
            errors.mobileNumber = "Invalid mobile number.";
        }
        if (this.state.countryCode == null || this.state.countryCode.trim() == '') {
            formIsValid = false;
            errors.countryCode = "Required.";
        }
        if (this.state.email == null || this.state.email.trim() == '') {
            formIsValid = false;
            errors.email = "Please enter email.";
        }

        if (this.state.email != '') {
            let regEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!regEmail.test(this.state.email)) {
                formIsValid = false;
                errors.email = "Please enter valid email.";
            }
        }

        if (this.state.isPreventAccess != false) {
            if (this.state.preventReason == '') {
                formIsValid = false;
                errors.preventReason = "Please enter prevent reason.";
            }
        }

        if (this.state.isDaysBeforeRemind != false) {
            if (this.state.noOfDaysBeforeRemind == null || this.state.noOfDaysBeforeRemind == "" || this.state.noOfDaysBeforeRemind == 0) {
                formIsValid = false;
                errors.noOfDaysBeforeRemind = "Please enter no of days before remind.";
            }
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    async isAllowConfirm() {
        let isResult = false;
        await Swal.fire({
            icon: 'success',
            title: 'Delete Driver',
            html: "Are you sure want to delete driver?",
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonText: 'Delete',
            cancelButtonText: 'No',
        }).then((result) => {
            if (result.isConfirmed) {
                isResult = true;
            }
        });
        return isResult;
    }
    onfailure(title, resultMessage) {
        Swal.fire({
            showCloseButton: true,
            icon: 'error',
            title: (title === null || title.trim() === '') ? 'Oops...' : title,
            text: (resultMessage === null || resultMessage.trim() === '') ? 'Something went wrong!' : resultMessage.trim(),
        })
    }
    async deleteDriver(e, dataresult) {
        e.preventDefault();
        try {
            const isConfirm = await this.isAllowConfirm();
            if (!isConfirm) {
                return;
            }
            var deleteDriverRequest = new Object();
            deleteDriverRequest.DriverId = parseInt(dataresult.id);
            const requestParams = getRequestParams('POST', deleteDriverRequest);
            const response = await fetch("driver-api/delete", requestParams);
            const data = await response.json();
            if (data.isSuccess) {
                Swal.fire({
                    icon: data.isSuccess ? 'success' : 'error',
                    title: data.isSuccess ? 'success' : 'Oops...',
                    text: data.resultMessage,
                }).then((result) => {
                    /* Read more about isConfirmed, isDenied below */
                    if (data.isSuccess) {
                        this.getDriverList();
                    }
                });
            } else {
                this.onfailure('Failed to Delete driver.', data.resultMessage);
            }
        } catch (e) {
            //debugger;
        }
    }
    removeImageHandle() {
        this.setState({
            fileGuid: '00000000-0000-0000-0000-000000000000',
            driverFile: "../../dist/img/avatar5.png",
            driverSelectedFile: []
        });
    }
    handleGenerateQRCode(e, data) {
        e.preventDefault();
        this.setState({
            qrCodeModalIsOpen: true,
            qrCodeDriverNumber: data.userName,
        });
    }
    handleQRCodeCloseState = () => {
        this.setState({
            qrCodeModalIsOpen: false,
        });
    }
    handleQRCodeOpenState(e, data) {
        //e.preventDefault();
    }
    handleDownloadDriverQRCode(e) {
        e.preventDefault();
        const canvas = document.getElementById(this.state.qrCodeDriverNumber);
        const pngUrl = canvas
            .toDataURL("image/png")
            .replace("image/png", "image/octet-stream");
        let downloadLink = document.createElement("a");
        downloadLink.href = pngUrl;
        downloadLink.download = "DriverQRCode-" + this.state.qrCodeDriverNumber + ".png";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    }

    editDriverControl(e, data) {
        e.preventDefault();
        this.setState({
            isOpenDriverModal: true,
            driverId: data === null ? 0 : data.id
        });
    }

    openPasswordModal(e, data) {
        e.preventDefault();
        this.refs.changePasswordModal.showModal(data);
    }

    openLocationModal(e, data) {
        e.preventDefault();
        this.refs.setUserLocationModal.showModal(data);
    }

    openDocumentModal(e, data) {
        e.preventDefault();
        this.refs.driverDocumentComponent.showModal(data);
    }

    openMasterHistoryModal(e, data) {
        e.preventDefault();
        let userName = data.fullName !== null ? data.fullName : '';
        if (userName.trim() === '') {
            userName = data.userName !== null ? data.userName : '';
        }
        this.refs.masterHistoryComponent.showModal('driver-api', 'Driver', userName, data.id === null ? 0 : Number(data.id));
    }

    async afterOpenDriverModal() {
        this.setState({ loadPanelVisible: true });
        if (parseInt(this.state.driverId) <= 0) {
            this.setState({
                userName: "",
                password: "",
                firstName: "",
                lastName: "",
                mobileNumber: "",
                countryCode: "",
                email: "",
                address: "",
                isActive: true,
                isLocked: false,
                inactiveReason: '',
                lockedReason: '',
                isPreventAccess: false,
                preventReason: '',
                licenceNumber: '',
                licenceDocumentId: 0,
                documentName: '',
                expiryDate: '',
                validFrom: '',
                isDaysBeforeRemind: false,
                noOfDaysBeforeRemind: 0,
                driverFile: '../../dist/img/avatar5.png',
                fileGuid: '00000000-0000-0000-0000-000000000000',
              
            });

        } else {
            try {
                const requestParams = getRequestParams('GET', '');
                const response = await fetch('driver-api/list/' + this.state.driverId, requestParams);
                const data = await response.json();

                const user = data.userDetails[0];
                this.setState({
                    userName: user.userName,
                    password: user.password,
                    firstName: user.firstName,
                    lastName: user.lastName,
                    mobileNumber: user.mobile,
                    countryCode: user.countryCode,
                    email: user.email,
                    address: user.address1,
                    isActive: user.enable,
                    isLocked: user.isLockedOut,
                    inactiveReason: user.inactiveReason,
                    lockedReason: user.lockedOutReason,
                    isPreventAccess: user.isPreventAccess,
                    preventReason: user.preventAccessNote,
                    licenceDocumentId: user.driverLicenseDocumentId,
                    documentName: user.driverLicenseDocumentName,
                    licenceNumber: user.driverLicenseNumber,
                    expiryDate: user.licenseValidFrom != null ? new Date(user.licenseValidFrom) : "",
                    validFrom: user.licenseValidUpTo != null ? new Date(user.licenseValidUpTo) : "",
                    isDaysBeforeRemind: user.licenseIsReminder,
                    noOfDaysBeforeRemind: user.licenseDaysReminder,
                    driverFile: '../../dist/img/avatar5.png',
                    fileGuid: user.fileGuid
                });

                if (user.fileGuid != '00000000-0000-0000-0000-000000000000') {
                    const requestParams = getRequestParams('GET', '');
                    const response = await fetch('file-api/download/' + user.fileGuid, requestParams);
                    const data = await response.json();
                    this.setState({ driverFile: 'data:' + data.mimeType + ';base64,' + data.fileContent });
                }

            } catch (e) {
                this.setState({ loadPanelVisible: false });
                console.log(e);
            }
        }
        this.setState({ loadPanelVisible: false });
    }

    async driverProfileUpload() {
        if (this.state.driverSelectedFile.size != undefined) {
            debugger;
            if (this.state.driverSelectedFile.size > 0) {
                const url = 'file-api/file-upload/';
                const formData = new FormData();
                formData.append('body', this.state.driverSelectedFile);

                const config = {
                    headers: {
                        'content-type': 'multipart/form-data',
                        'UserId': sessionStorage.getItem('session_userId'),
                        'Authorization': 'Bearer ' + sessionStorage.getItem('session_token'),
                        'CultureCode': sessionStorage.getItem('session_culturecode'),
                    },
                };

                const response = await post(url, formData, config);
                debugger;
                const data = await response.data;
                if (data !== null) {
                    this.setState({
                        fileGuid: data.fileGuid
                    });
                }
            }
        }
    }

    async handleDriverSubmit(e) {
        e.preventDefault();
        if (this.handleValidation()) {
            this.setState({ isSubmited: true });
            await this.driverProfileUpload();

            var newObject = new Object();
            newObject.Id = this.state.driverId;
            newObject.UserTypeId = parseInt(19);
            newObject.UserName = this.state.userName.trim();
            newObject.Password = this.state.password.trim();
            newObject.FirstName = this.state.firstName.trim();
            newObject.LastName = this.state.lastName.trim();
            newObject.Email = this.state.email.trim();
            newObject.Address = this.state.address;
            newObject.Mobile = this.state.mobileNumber != null ? this.state.mobileNumber.trim().replace("(", "").replace(")", "").replace("-", "").replace(" ", "") : "";
            newObject.ActionTypeId = 4;
            newObject.CountryCode = this.state.countryCode.trim();
            newObject.Enable = this.state.isActive;
            newObject.IsLockedOut = this.state.isLocked;
            newObject.InactiveReason = this.state.inactiveReason;
            newObject.LockedReason = this.state.lockedReason;
            newObject.DriverLicenseDocumentId = this.state.licenceDocumentId;
            newObject.DriverLicenseNumber = this.state.licenceNumber;
            newObject.DriverLicenseDocumentName = this.state.documentName;
            newObject.LicenseValidFrom = this.state.validFrom != "" ? this.state.validFrom + " 00:00" : "";
            newObject.LicenseValidUpTo = this.state.expiryDate != "" ? this.state.expiryDate + " 00:00" : "";
            newObject.LicenseIsReminder = this.state.isDaysBeforeRemind;
            newObject.LicenseDaysReminder = this.state.noOfDaysBeforeRemind == "" ? 0 : parseInt(this.state.noOfDaysBeforeRemind);
            newObject.FileGuid = this.state.fileGuid;
            newObject.AllowDriverDocumentVerification = sessionStorage.getItem('session_allowDriverDocumentVerification')

            try {
                const requestParams = getRequestParams('POST', newObject);
                let path = this.state.driverId > 0 ? 'user-api/update-user-details' : 'user-api/save-user-details';
                const response = await fetch(path, requestParams);
                const data = await response.json();

                Swal.fire({
                    icon: data.isSuccess ? 'success' : 'error',
                    title: data.isSuccess ? 'Success' : 'Oops...',
                    text: data.resultMessage,
                }).then((result) => {
                    /* Read more about isConfirmed, isDenied below */
                    if (data.isSuccess) {
                        if (result.isConfirmed) {
                            //this.driverProfileUpload();
                            this.closeDriverModal();
                            this.getDriverList();
                        }
                    } else {
                        this.setState({ isSubmited: false })
                    }
                })
            } catch (e) {
                this.setState({ isSubmited: false })
            }
        }
    }

    closeDriverModal() {
        this.setState({
            isOpenDriverModal: false,
            isSubmited: false,
            driverId: 0,
            userName: '',
            password: '',
            firstName: '',
            lastName: '',
            mobileNumber: '',
            countryCode: '',
            email: '',
            address: '',
            isActive: true,
            isLocked: false,
            inactiveReason: '',
            lockedReason: '',
            isPreventAccess: false,
            preventReason: '',
            documentName: '',
            licenceNumber: '',
            documentName: '',
            expiryDate: '',
            validFrom: '',
            isDaysBeforeRemind: false,
            noOfDaysBeforeRemind: 0,
            driverFile: '../../dist/img/avatar5.png',
            fileGuid: '00000000-0000-0000-0000-000000000000',
            driverSelectedFile: [],
            errors: {
                userName: '',
                password: '',
                firstName: '',
                lastName: '',
                mobileNumber: '',
                countryCode: '',
                email: '',
                preventReason: '',
                noOfDaysBeforeRemind: '',
            }
        });
    }

    render() {
        const renderGridCell = (data) => {            
            return <div>
                <a href="#" className="fas fa-pen icon text-info" title="Edit" onClick={(e) => { this.editDriverControl(e, data.data) }} ></a>&nbsp;&nbsp;
                <a href="#" className="fas fa-key icon text-info" title="Change Password" onClick={(e) => { this.openPasswordModal(e, data.data) }}></a>&nbsp;&nbsp;
                <a href="#" className="fas fa-map-marker-alt text-info" title="Set Location" onClick={(e) => { this.openLocationModal(e, data.data) }}></a>&nbsp;&nbsp;
                <a href="#" title="Download QR Code" onClick={(e) => { this.handleGenerateQRCode(e, data.data) }} ><i className="fas fa-qrcode"></i></a>&nbsp;&nbsp;
                <a href="#" className="fas fa-history icon text-info" title="History" onClick={(e) => { this.openMasterHistoryModal(e, data.data) }}></a>&nbsp;&nbsp;
                <a href="#" className="fas fa-file text-info" title="Document" onClick={(e) => { this.openDocumentModal(e, data.data) }}></a>&nbsp;&nbsp;
                {this.state.doNotDeleteDriver === true ? "" : <a href="#" className="fas fa-trash-alt icon text-info" title="Delete Driver User" onClick={(e) => { this.deleteDriver(e, data.data) }}></a>}
            </div>;
        }
        return (
            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                <h1 className="m-0 text-dark">Drivers</h1>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                <ol className="breadcrumb float-sm-right">
                                    <NavItem><NavLink tag={Link} to="#" onClick={(e) => { this.editDriverControl(e, null) }} className="btn btn-block btn-outline-secondary btn-sm" title="Add Driver"><i className="fas fa-plus"></i> Add Driver</NavLink></NavItem>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="content">
                    <div className="card card-grid">
                        <div className="card-body">
                            <DataGrid
                                dataSource={this.state.datasource}
                                keyExpr="id"
                                selection={{ mode: 'single' }}
                                columnsAutoWidth={false}
                                showColumnLines={false}
                                showRowLines={true}
                                showBorders={true}
                                rowAlternationEnabled={true}
                                showBorders={true}
                                allowColumnResizing={true}
                                columnResizingMode='widget'
                                onToolbarPreparing={this.onToolbarPreparing}>
                                <Column dataField="id" width={110} caption="" allowFiltering={false} allowSorting={false} cellRender={renderGridCell} />
                                <Column dataField="userName" caption="User Name" width={150} />

                                <Column dataField="fullName" caption="Driver Name" />
                                <Column dataField="email" caption="Email" allowFiltering={false} allowSorting={false} />
                                <Column dataField="mobile" caption="Mobile Number" allowFiltering={false} allowSorting={false} />
                                <Column dataField="driverLicenseNumber" caption="Licence Number" allowFiltering={false} allowSorting={false} />
                                <Column dataField="userStatus" caption="Driver Status" width={150} />

                                <SortByGroupSummaryInfo summaryItem="count" />
                                <GroupPanel visible={true} />
                                <HeaderFilter visible={true} />
                                <SearchPanel visible={true} highlightCaseSensitive={true} width={240} placeholder="Search..." />
                                <Grouping autoExpandAll={true} />
                                <Paging defaultPageSize={20} />
                                <Pager showPageSizeSelector={true} allowedPageSizes={[5, 10, 20, 50, 100]} showInfo={true} />
                                <Export enabled={true} allowExportSelectedData={false} />
                                <ColumnChooser enabled={true} />
                                <ColumnFixing enabled={true} />

                            </DataGrid>
                        </div>
                    </div>
                </div>
                <Modal ariaHideApp={false}
                    isOpen={this.state.isOpenDriverModal}
                    style={customStyles}
                    className={"react-modal react-modal-driverlist"}
                    onAfterOpen={this.afterOpenDriverModal}
                    onRequestClose={this.closeDriverModal}
                    shouldCloseOnOverlayClick={false}
                    contentLabel="Example Modal">
                    <form method="post" encType="multipart/form-data" onSubmit={this.handleDriverSubmit} style={this.state.isSubmited ? { pointerEvents: "none", opacity: "0.4" } : {}}>
                        <div className="modal-header">
                            <h6 className="modal-title">{this.state.driverId > 0 ? "Modify Driver" : "Add Driver"}</h6>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.closeDriverModal}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                    <div className="row">
                                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                            <div className="form-group">
                                                <label>Username <span className="text-danger">*</span></label>
                                                <input type="text" className="form-control form-control-sm" name="userName" disabled={this.state.driverId > 0}
                                                    placeholder="Enter username" maxLength="25" title="User Name" value={this.state.userName} onChange={this.handleInputChange} />
                                                {this.state.errors["userName"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["userName"]}</span>}
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6" style={{ display: this.state.driverId > 0 ? 'none' : 'block' }}>
                                            <div className="form-group">
                                                <label htmlFor="">Password  <span className="text-danger">*</span>
                                                    {/*<i className="fas fa-info-circle text-info" data-tip data-for="passwordTooltip"></i>*/}
                                                </label>
                                                <input type="password" className="form-control form-control-sm" name="password" autoComplete="new-password" disabled={this.state.driverId > 0} placeholder="Enter password" minLength="5" maxLength="25" title="Password" value={this.state.password} onChange={this.handleInputChange} />
                                                {this.state.errors["password"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["password"]}</span>}
                                                {/*<ReactTooltip id="passwordTooltip" place="top" effect="solid">*/}
                                                {/*    <div className="form-group">*/}
                                                {/*        <ul>*/}
                                                {/*            <li>At least {this.state.vMinLength} characters long</li>*/}
                                                {/*            <li>At least {this.state.vMinLowerCaseLetter} lowercase character</li>*/}
                                                {/*            <li>At least {this.state.vMinUpperCaseLetter} uppercase character</li>*/}
                                                {/*            <li>At least {this.state.vMinNumber} number, symbol, or whitespace character</li>*/}
                                                {/*            <li>At least {this.state.vMinSpecialCharacter} special character</li>*/}
                                                {/*        </ul>*/}
                                                {/*    </div>*/}
                                                {/*</ReactTooltip>*/}
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                            <div className="form-group">
                                                <label>First Name <span className="text-danger">*</span></label>
                                                <input type="text" className="form-control form-control-sm" name="firstName" placeholder="Enter first name" maxLength="50" title="First Name" value={this.state.firstName} onChange={this.handleInputChange} />
                                                {this.state.errors["firstName"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["firstName"]}</span>}
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                            <div className="form-group">
                                                <label>Last Name <span className="text-danger">*</span></label>
                                                <input type="text" className="form-control form-control-sm" name="lastName" placeholder="Enter last name" maxLength="50" title="Last Name" value={this.state.lastName} onChange={this.handleInputChange} />
                                                {this.state.errors["lastName"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["lastName"]}</span>}
                                            </div>
                                        </div>
                                        <div className="col-xs-1 col-sm-2 col-md-2 col-lg-2">
                                            <div className="form-group">
                                                <label>Code <span className="text-red">*</span></label>
                                                <input type="text" className="form-control form-control-sm" name="countryCode" placeholder="+1" maxLength="2" title="Country Code" value={this.state.countryCode} onChange={this.handleInputChange} />
                                                {this.state.errors["countryCode"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["countryCode"]}</span>}
                                            </div>
                                        </div>
                                        <div className="col-xs-5 col-sm-5 col-md-4 col-lg-4">
                                            <div className="form-group">
                                                <label>Mobile Number <span className="text-danger">*</span></label>
                                                <NumberFormat className="form-control form-control-sm" name="mobileNumber" placeholder="(000) 000-0000" title="Mobile Number" value={this.state.mobileNumber} onChange={this.handleInputChange} format="(###) ###-####" />
                                                {this.state.errors["mobileNumber"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["mobileNumber"]}</span>}
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                            <div className="form-group">
                                                <label>Email <span className="text-red">*</span></label>
                                                <input type="text" className="form-control form-control-sm" name="email" placeholder="test@domain.com" maxLength="100" title="Email" value={this.state.email} onChange={this.handleInputChange} />
                                                {this.state.errors["email"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["email"]}</span>}
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                            <div className="form-group">
                                                <label>Driver Photo </label>
                                                <div className="input-group">
                                                    <div className="col-lg-8 custom-file">
                                                        <input type="file" name="driverFile" className="custom-file-input" onChange={this.handleInputChange} />
                                                        <label className="custom-file-label" >Choose file</label>
                                                    </div>
                                                    <div className="col-lg-4">
                                                        <button type="button" style={{ display: (this.state.fileGuid != '00000000-0000-0000-0000-000000000000') ? 'block' : 'none' }} className="btn btn-custom-gray btn-sm" onClick={this.removeImageHandle} title="Remove Photo"><i className="fas fa-times"></i> Remove Image</button>
                                                    </div>
                                                </div>
                                                <div className="text-center">
                                                    <img className="img-circle" style={{ height: 200 + "px", width: 200 + "px" }} src={this.state.driverFile} alt="Driver photo" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                    <div className="row">
                                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                            <div className="form-group">
                                                <label>Document Name</label>
                                                <input type="text" className="form-control form-control-sm" name="documentName" placeholder="Enter document name" maxLength="50" title="Document Name" value={this.state.documentName} onChange={this.handleInputChange} />
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                            <div className="form-group">
                                                <label>Licence Number</label>
                                                <input type="text" className="form-control form-control-sm" name="licenceNumber" placeholder="Enter licence number" maxLength="50" title="Licence Number" value={this.state.licenceNumber} onChange={this.handleInputChange} />
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                            <div className="form-group">
                                                <label>Valid From </label>
                                                <DateBox type="date"
                                                    className="form-control form-control-sm"
                                                    name="fromDate"
                                                    placeholder="mm/dd/yyyy"
                                                    useMaskBehavior={true}
                                                    defaultValue={this.state.validFrom}
                                                    onValueChanged={this.handleValidFromDateChange}
                                                    width="100%"
                                                    disabled={false}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                                            <div className="form-group">
                                                <label>Expiry Date </label>
                                                <DateBox type="date"
                                                    className="form-control form-control-sm"
                                                    name="fromDate"
                                                    placeholder="mm/dd/yyyy"
                                                    useMaskBehavior={true}
                                                    defaultValue={this.state.expiryDate}
                                                    onValueChanged={this.handleExpiryDateChange}
                                                    width="100%"
                                                    disabled={false}
                                                />
                                            </div>
                                        </div>

                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <div className="form-group">
                                                <div className="form-check">
                                                    <input className="form-check-input" type="checkbox" id="isDaysBeforeRemind" name="isDaysBeforeRemind" checked={this.state.isDaysBeforeRemind} onChange={this.handleInputChange} />
                                                    <label className="form-check-label" htmlFor="isDaysBeforeRemind"> Days Before Remind &nbsp;&nbsp;<i>(If applied, please enter days before expiry)</i></label>
                                                    <input type="text" className="form-control form-control-sm" name="noOfDaysBeforeRemind" placeholder="00" maxLength="2" title="Days Before Remind" value={this.state.noOfDaysBeforeRemind} onChange={this.handleInputChange} />
                                                    {this.state.errors["noOfDaysBeforeRemind"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["noOfDaysBeforeRemind"]}</span>}
                                                </div>
                                            </div>
                                        </div>


                                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12" style={{ display: this.state.driverId <= 0 ? 'none' : 'block' }}>
                                            <div className="form-group">
                                                <div className="form-check">
                                                    <input className="form-check-input" type="checkbox" id="isActive" name="isActive" checked={this.state.isActive} onChange={this.handleInputChange} />
                                                    <label className="form-check-label" htmlFor="isActive"> Is Active &nbsp;<i>(If Inactive, please enter reason)</i></label>
                                                </div>
                                                <textarea className="form-control form-control-sm" name="inactiveReason" placeholder="Type inactive reason" maxLength="100" title="Inactive Reason" value={this.state.inactiveReason} onChange={this.handleInputChange} />
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12" style={{ display: this.state.driverId <= 0 ? 'none' : 'block' }}>
                                            <div className="form-group">
                                                <div className="form-check">
                                                    <input className="form-check-input" type="checkbox" id="isLocked" name="isLocked" checked={this.state.isLocked} onChange={this.handleInputChange} />
                                                    <label className="form-check-label" htmlFor="isLocked" style={{ fontSize: "inherit" }}> Is Locked-out &nbsp;&nbsp;<i>(If Locked out, please enter reason)</i></label>
                                                </div>
                                                <textarea className="form-control form-control-sm" name="lockedReason" placeholder="Type locked-out reason" maxLength="100" title="Locked-out Reason" value={this.state.lockedReason} onChange={this.handleInputChange} />
                                            </div>
                                        </div>
                                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12" style={{ display: this.state.driverId <= 0 ? 'none' : 'block' }}>
                                            <div className="form-group">
                                                <div className="form-check">
                                                    <input className="form-check-input" type="checkbox" id="isPreventAccess" name="isPreventAccess" checked={this.state.isPreventAccess} onChange={this.handleInputChange} />
                                                    <label className="form-check-label" htmlFor="isPreventAccess" style={{ fontSize: "inherit" }}> Prevent Access &nbsp;&nbsp;<i>(If prevent access, please enter reason)</i></label>
                                                </div>
                                                <textarea className="form-control form-control-sm" name="preventReason" placeholder="Type prevent access reason" maxLength="100" title="Prevent Reason" value={this.state.preventReason} onChange={this.handleInputChange} />
                                                {this.state.errors["preventReason"].length > 0 && <span className='error invalid-feedback'>{this.state.errors["preventReason"]}</span>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">

                                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">


                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="submit" className="btn btn-success btn-sm" onClick={this.handleDriverSubmit} >
                                {this.state.isSubmited && <span title="In-process"><i className="fas fa-spinner fa-spin"></i> In-process</span>}
                                {!this.state.isSubmited && <span title="Submit"><i className="fas fa-check"></i> Submit</span>}
                            </button>
                            <button type="button" className="btn btn-custom-gray btn-sm" onClick={this.closeDriverModal} title="Close"><i className="fas fa-times"></i> Close</button>
                        </div>
                    </form>
                </Modal>
                <Modal ariaHideApp={false}
                    isOpen={this.state.qrCodeModalIsOpen}
                    style={qrCodeCustomStyles}
                    className={"react-modal"}
                    onAfterOpen={this.handleQRCodeOpenState}
                    onRequestClose={this.handleQRCodeCloseState}
                    shouldCloseOnOverlayClick={false}
                    contentLabel="Example Modal">
                    <form method="post" onSubmit={this.handleDownloadDriverQRCode} style={this.state.isSubmited ? { pointerEvents: "none", opacity: "0.4" } : {}}>
                        <div className="modal-header">
                            <h6 className="modal-title">QR Code - <strong>{this.state.qrCodeDriverNumber}</strong></h6>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.handleQRCodeCloseState}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body text-center">
                            <div className="row">
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <QRCode id={this.state.qrCodeDriverNumber} value={this.state.qrCodeDriverNumber} size={350} level={"H"} includeMargin={true} />
                                </div>
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <b>{this.state.qrCodeDriverNumber}</b>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="submit" className="btn btn-success btn-sm" onClick={this.handleDownloadDriverQRCode}>
                                {this.state.isSubmited && <span title="In-process"><i className="fas fa-spinner fa-spin"></i> In-process</span>}
                                {!this.state.isSubmited && <span title="Download QR Code"><i className="fas fa-check"></i> Download QR Code</span>}
                            </button>
                            <button type="button" className="btn btn-custom-gray btn-sm" onClick={this.handleQRCodeCloseState}><i className="fas fa-times"></i> Close</button>
                        </div>
                    </form>
                </Modal>
                <ChangePasswordComponent ref="changePasswordModal" source="driveruser"  />
                <SetUserLocationComponent ref="setUserLocationModal" sourceurl="driverUsers"  />
                <MasterHistoryComponent ref="masterHistoryComponent" />
                <DriverDocumentComponent ref="driverDocumentComponent" isDisplayDriverList="false"  />
                <LoadPanel
                    shadingColor="rgba(0,0,0,0.4)"
                    position={position}
                    visible={this.state.loadPanelVisible}
                    showIndicator={true}
                    shading={true}
                    showPane={true}
                    closeOnOutsideClick={false}
                />
            </div>
        );
    }
}